export default "__VITE_ASSET__kfWNRS19__"